<div id="http-loader" *ngIf="isSpinnerVisible || loaderService.isLoading" style="z-index: 99999 !important">
  <div id="preloader">
    <div id="loader"></div>
  </div>
</div>
